import React from 'react';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';

import Modal from '../../../realize_overrides/components/modal/modal.jsx';
import ButtonGroup from '../../../realize_overrides/components/button/button_group.jsx';

import DocumentStoreItem from '../../models/document_store_item';
import { DocumentActions, DocumentStore } from '../../reflux/document_store';

import { DocumentLocks } from "../../constants/document_locks";

import DocumentModalIds from '../../../document/constants/document_modal_ids.js';
import DocumentSubmitDataContainers from '../../../document/constants/document_submit_data_containers';
import { ProcessAPI } from 'lecom-api';

import CreateDocumentModal from '../../../document/components/modal/create_document_modal';
import ImportDocumentModal from '../../../document/components/modal/import_document_modal';
import DetachDocumentModal from '../../../document/components/modal/detach_document_modal';
import ManageDocumentModal from '../../../document/components/modal/manage_document_modal';
import HandleDuplicateDocumentModal from '../../../document/components/modal/handle_duplicate_document_modal';
import HandleDivergentDocumentVersionsModal from '../../../document/components/modal/handle_divergent_document_versions_modal';
import DigitalSignatureModal from '../../../document/components/modal/digital_signature_modal';
import FlashMessages from '../../../flash_message/components/flash_messages.jsx';
import RealizeFlash from 'realize/components/flash/flash';
import ValuesParserInterceptor from '../../../rest_client/interceptors/values_parser_interceptor.js';

const Realize = {
	i18n: window.Realize.i18n,
	Modal: Modal,
	ModalHeader: window.ModalHeader,
	ModalContent: window.ModalContent,
	ModalFooter: window.ModalFooter,
	Flash: window.Flash,
	ContainerMixin: window.ContainerMixin
};

@mixin.decorate(Realize.ContainerMixin)
@mixin.decorate(Reflux.listenTo(DocumentStore, 'onDocumentStoreLoad'))
export default class DocumentModal extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		name: PropTypes.string,
		title: PropTypes.string,
		className: PropTypes.string,
		type: PropTypes.string,
		buttons: PropTypes.array,
		store: PropTypes.object,
		onDismiss: PropTypes.func,
		onOpen: PropTypes.func
	};

	static defaultProps = {
		id: '',
		name: '',
		title: '',
		className: '',
		type: '',
		buttons: [],
		store: new DocumentStoreItem(),
		onDismiss: () => {},
		onOpen: () => {},
		onCloseModal: () => {},
		onFocus: () => {}
	};

	propsToForward() {
		return ['id', 'name', 'store'];
	}

	constructor(props) {
		super(props);
		this.dismissModal = this.dismissModal.bind(this);
		this.dismissFlashMessage = this.dismissFlashMessage.bind(this);
	}

	onDocumentStoreLoad(store, storeId) {
		this.setState({ store: store[storeId] });
	}

	get buttonDownloadDigitalSignature(){
		return this.state.store.digitalSignature.buttonDownloadDigitalSignature;
	}

	get selectedDuplicateDocument() {
		return this.state.store.selectedDuplicateDocument;
	}

	get duplicateDocumentSelected() {
		return this.selectedDuplicateDocument;
	}

	get type() {
		return this.state.store && this.state.store.type;
	}

	get documentCanBeDeleted() {
		return this.state.store.documentCanBeDeleted;
	}

	get fileIsSelected() {
		return this.state.store.documentFileSelected;
	}

	get fileTypeSelected() {
		const { submitData } = this.state.store;
		const createSubmitData = submitData[DocumentSubmitDataContainers.CREATE];

		return createSubmitData ? createSubmitData.defaultType : [];
	}

	get waitingForAction() {
		return this.state.store.waitingForAction;
	}

	get document() {
		return this.state.store.document;
	}

	get documentIsCheckedOut() {
		return this.document.checkedOut && !this.documentIsCheckedoutByOtherUser;
	}

	get documentIsCheckedoutByOtherUser() {
		return this.state.store.documentIsCheckedoutByOtherUser;
	}
	get documentIsReadonly() {
		return this.state.store.documentReadonly;
	}

	getTitle() {
		const currentProcess = ProcessAPI.currentProcess();

		switch(this.type) {
			case DocumentModalIds.DETACH_DOCUMENT:
				if (this.documentCanBeDeleted && currentProcess.isPublic()) {
					return 'template.titles.delete';
				} else {
					return this.documentCanBeDeleted
							? 'template.titles.detachOrDelete'
							: 'template.titles.detach';
				}
			case DocumentModalIds.CREATE_DOCUMENT:
				return 'template.titles.create';
			case DocumentModalIds.HANDLE_DIVERGENT_DOCUMENT_VERSIONS:
				return 'template.titles.handleDivergentVersions';
			case DocumentModalIds.HANDLE_DUPLICATE_DOCUMENT:
				return 'template.titles.handleDuplicate';
			case DocumentModalIds.IMPORT_DOCUMENT:
				return 'template.titles.import';
			case DocumentModalIds.MANAGE_DOCUMENT:
				return 'template.titles.manage';
			case DocumentModalIds.DIGITAL_SIGNATURE_DOCUMENT:
				return 'template.titles.digitalSignature';
		}
	}

	getInstance() {
		switch(this.type) {
			case DocumentModalIds.DETACH_DOCUMENT:
				return <DetachDocumentModal {...this.buildProps()}/>;
			case DocumentModalIds.CREATE_DOCUMENT:
				return <CreateDocumentModal {...this.buildProps()}/>;
			case DocumentModalIds.HANDLE_DIVERGENT_DOCUMENT_VERSIONS:
				return <HandleDivergentDocumentVersionsModal {...this.buildProps()}/>;
			case DocumentModalIds.HANDLE_DUPLICATE_DOCUMENT:
				return <HandleDuplicateDocumentModal {...this.buildProps()}/>;
			case DocumentModalIds.IMPORT_DOCUMENT:
				return <ImportDocumentModal {...this.buildProps()}/>;
			case DocumentModalIds.MANAGE_DOCUMENT:
				return <ManageDocumentModal {...this.buildProps()}/>;
			case DocumentModalIds.DIGITAL_SIGNATURE_DOCUMENT:
				return <DigitalSignatureModal {...this.buildProps()} />
		}
	}

	getButtons() {
		switch(this.type) {
			case DocumentModalIds.DETACH_DOCUMENT:
				var currentProcess = ProcessAPI.currentProcess();
				var buttons = [];

				if (currentProcess.isPublic()) {
					if (this.documentCanBeDeleted) {
						buttons.push(this.buildDeleteButtonProps());
					} else {
						buttons.push(this.buildDetachButtonProps());
					}

				} else {
					buttons.push(this.buildDetachButtonProps());
					if (this.documentCanBeDeleted) {
						buttons.push(this.buildDeleteButtonProps());
					}
				}
				return buttons;
			case DocumentModalIds.CREATE_DOCUMENT:
				return this.buildCreateButtonProps();
			case DocumentModalIds.HANDLE_DIVERGENT_DOCUMENT_VERSIONS:
				return this.buildDivergentButtonProps();
			case DocumentModalIds.HANDLE_DUPLICATE_DOCUMENT:
				return this.buildDuplicateButtonProps();
			case DocumentModalIds.IMPORT_DOCUMENT:
				return this.buildImportButtonProps();
			case DocumentModalIds.MANAGE_DOCUMENT:
				return this.buildManageButtonProps();
			case DocumentModalIds.DIGITAL_SIGNATURE_DOCUMENT:
				return this.buildDigitalSignatureButtonProps();
		}
	}

	buildManageButtonProps() {
		var buttons = [];

		if (this.documentIsReadonly) return buttons;

		if (!this.documentIsCheckedOut) {
			buttons.push({
				name: Realize.i18n.t('template.actions.checkout'),
				element: 'a',
				style: 'primary',
				role: 'button',
				onClick: DocumentActions.checkoutDocument.bind(this, this.id),
				disabled: this.waitingForAction,
				id: 'btn-document-checkout',
			});
		}
		else {
			buttons = [{
				name: Realize.i18n.t('template.actions.cancelCheckout'),
				element: 'a',
				icon: 'cancel',
				role: 'button',
				style: 'danger',
				onClick: DocumentActions.cancelCheckoutDocument.bind(this, this.id),
				disabled: this.waitingForAction,
				id: 'btn-cancel-checkout-document'
			}, {
				name: Realize.i18n.t('template.actions.checkin'),
				element: 'a',
				role: 'button',
				style: 'primary',
				onClick: DocumentActions.checkinDocument.bind(this, this.id),
				disabled: this.waitingForAction,
				id: 'btn-checkin-document'
			}];
		}

		return buttons;
	}

	buildImportButtonProps() {
		return [{
			name: Realize.i18n.t('template.actions.import'),
			isLoading: this.state.store.documentUploading,
			element: 'a',
			style: 'primary',
			role: 'button',
			disabled: this.waitingForAction || !this.fileIsSelected,
			onClick: this.submitImportDocument.bind(this),
			className: 'button-import-document'
		}];
	}

	submitImportDocument(){
		this.setState({closeRealize: false}); 
		DocumentActions.importDocument.bind(this, this.id)(); 		
	}

	submitCreateDocument(){
		this.setState({closeRealize: false}); 
		DocumentActions.createDocument.bind(this, this.id)(); 		
	}

	buildCreateButtonProps() {
		return [{
			name: Realize.i18n.t('template.actions.create'),
			element: 'a',
			style: 'primary',
			role: 'button',
			disabled: this.waitingForAction || !this.fileTypeSelected,
			onClick: this.submitCreateDocument.bind(this),
			className: 'button-create-document'
		}];
	}

	buildDeleteButtonProps() {
		return {
			name: Realize.i18n.t('template.actions.delete'),
			element: 'a',
			style: 'primary',
			role: 'button',
			onClick: DocumentActions.deleteDocument.bind(this, this.id),
			disabled: this.waitingForAction,
			className: 'button-delete-document'
		};
	}

	buildDetachButtonProps() {
		var buttonDetachName = this.documentCanBeDeleted
			? Realize.i18n.t('template.actions.onlyDetach')
			: Realize.i18n.t('template.actions.detach');

		return {
			name: buttonDetachName,
			element: 'a',
			style: 'primary',
			role: 'button',
			onClick: DocumentActions.detachDocument.bind(this, this.id),
			disabled: this.waitingForAction,
			className: 'button-detach-document'
		};
	}

	buildDigitalSignatureButtonProps(){
		let buttonDownloadDigitalSignature = this.state.store.digitalSignature.buttonDownloadDigitalSignature;
		let errorCompatibility = this.state.store.digitalSignature.errorCompatibility;

		if(buttonDownloadDigitalSignature === true || errorCompatibility === true){
			return {
				name: Realize.i18n.t('template.actions.downloadDigitalSignature'),
				element: 'a',
				style: 'primary',
				onClick: DocumentActions.downloadDigitalSignature.bind(this, this.id),
				disabled: this.waitingForAction,
				id: 'downloadDigitalSignature'
			};
		}
		else {
			return {
				name: Realize.i18n.t('actions.close'),
				element: 'a',
				icon: 'close',
				style: 'cancel',
				disabled: this.waitingForAction,
				onClick: this.dismissModal,
				id: 'btn-close-digital-signature'
			};
		}
	}

	validateButtonSobrescrever() {
		var selectedDuplicateDocument = this.state.store.selectedDuplicateDocument;

		if(selectedDuplicateDocument !== null){
			var locksLength = selectedDuplicateDocument.locks.length;

			if(locksLength !== 0){
				var documentSelected = document.querySelector('.sobrescrever-documento');
				documentSelected.title = Realize.i18n.t('template.actions.notOverwrite');
			} else {
				var documentSelected = document.querySelector('.sobrescrever-documento');
				documentSelected.title = ''
			}
		}
	}

	buildDuplicateButtonProps() {
		var override = true;
		var selectedDuplicateDocument = this.state.store.selectedDuplicateDocument;
		if (selectedDuplicateDocument && selectedDuplicateDocument.id)
			override = selectedDuplicateDocument.locks.indexOf(DocumentLocks.OVERRIDE) === -1;

		return [{
			name: Realize.i18n.t('template.actions.duplicate'),
			element: 'a',
			style: 'primary',
			role: 'button',
			onClick: DocumentActions.duplicateDocument.bind(this, this.id),
			disabled: this.waitingForAction,
			className: 'duplicar-documento'
		}];
	}

	buildDivergentButtonProps() {
		return {
			name: Realize.i18n.t('template.actions.selectVersion'),
			element: 'a',
			style: 'primary',
			role: 'button',
			onClick: DocumentActions.selectDivergentDocumentVersion.bind(this, this.id),
			disabled: this.waitingForAction
		};
	}

	buildProps() {
		return {
			...this.props,
			store: this.state.store,
			id: this.id,
			readOnly: this.state.store.documentUploading
		}
	}

	get id() {
		return this.state.store._inputId
	}

	dismissModal() {
		// this.Instance.onCloseModal("documentModal");
		DocumentActions.closeDocumentModal(this.id, this.type); //, this.Instance.onDismiss
		
		if (this.type === DocumentModalIds.IMPORT_DOCUMENT) {			
			$(`#input__${this.id} input`).val('');
		}
	}

	dismissFlashMessage() {
		DocumentActions.dismissFlashMessage(this.id);
	}

	buildDismissButtonProps() {

		return {
			name: Realize.i18n.t('actions.close'),
			element: 'a',
			role: 'button',
			icon: 'close',
			style: 'cancel',
			disabled: this.waitingForAction,
			onClick: this.dismissModal,
			className: 'button-close-modal-document',
		};
	}

	buildButtonGroupProps() {
		return [this.buildDismissButtonProps()].concat(this.getButtons());
	}

	renderModalHeader() {
		return (<span className="h5-custom" tabIndex="0" id={`${this.id}_title`}>{Realize.i18n.t(this.getTitle())}</span>);
	}

	renderModalFlashRiquerid() {

		if(this.state.store && Object.prototype.toString.call(this.state.store._metadataValidationErrors) === "[object Object]" 
		&& Object.keys(this.state.store._metadataValidationErrors).length 
		&& !this.state.closeRealize 
		&& this.checkedFieldsRequired()) {
			return (
				<div className="row">
					<RealizeFlash message={Realize.i18n.t('form.validations.fields_required')} type={'error'} onDismiss={()=>{this.setState({closeRealize: true})}} />
				</div>
			)
		}
	}

	checkedFieldsRequired() {
		if(this.state.store && this.state.store.template && this.state.store.template.fields) {
			let value = 0;
			let keys = Object.keys(this.state.store.template.fields);
			let fields = this.state.store.template.fields;

			keys.forEach((key) => {
				if(fields[key].validations.length !== 0) {
					value++;
				}
			})

			let submitData = this.state.store._submitData;

			if(submitData.CREATE){
				if(submitData.CREATE && submitData.CREATE.metadata === undefined)
					return true
			}
			else if(submitData.IMPORT){
				if(submitData.IMPORT && submitData.IMPORT.metadata === undefined)
				return true
			}


			return ((submitData.CREATE && submitData.CREATE.metadata.length < value) || (submitData.IMPORT && submitData.IMPORT.metadata.length < value));
		}
		return false;
	}

	renderModalFlash() {
		const flashMessage = this.state.store.flashMessage;
		if(!!flashMessage)
			return (
			<div className="row">
				<RealizeFlash {...flashMessage} onDismiss={this.dismissFlashMessage} />
			</div>
		);
		else
			return <span />;
	}

	renderModalButtons() {
		return <ButtonGroup buttons={this.buildButtonGroupProps()}/>;
	}

	renderSpinnerModalDigitalSignature(){
		const openModalSignature = this.state.store.digitalSignature.openModalSignature;
		if(openModalSignature === true){
			let {noDigitalSign, waitingForTheSignedDocument, connectingDigitalSignService, errorCompatibility} = this.state.store.digitalSignature;

			if(noDigitalSign === true || waitingForTheSignedDocument === true || connectingDigitalSignService === true && (errorCompatibility === false)){
				return (
					<div className="left" style={{ lineHeight: '32px', display: 'inline-flex' }}>
						<Spinner />
						<p style={{paddingLeft: '12px', fontSize: '17px'}}>Processando</p>
					</div>
				)
			}
		}
	}

	render() {

		if (!this.state || !this.getInstance()) return <span />;

		return (
			<Realize.Modal id='documentModal' key={`documentModal-${this.id}`} dismissible={false} className={this.props.className} ready={this.props.onOpen} isMobile={this.props.isMobile} onFocus={this.props.onFocus}>
				<Realize.ModalHeader>
					{this.renderModalHeader()}					
				</Realize.ModalHeader>
				<Realize.ModalContent>
					{this.renderModalFlash()}
					{this.renderModalFlashRiquerid()}
					<FlashMessages id="flash-document-modal" />
					{this.getInstance()}
				</Realize.ModalContent>
				<Realize.ModalFooter className={'right-align'}>
					{this.renderModalButtons()}
					{this.state.store.documentUploading  ? (
						<div className="left" style={{ lineHeight: '32px', display: 'inline-flex' }}>
							<Spinner />
							<p style={{paddingLeft: '12px', fontSize: '17px'}}>Processando</p>
						</div>
					) : null}
					{this.renderSpinnerModalDigitalSignature()}
				</Realize.ModalFooter>
			</Realize.Modal>
			// onFocus={this._handleFocus.bind(this)}
		);
	}
}
